import {btnColorSetup} from '../btn-setup/btnStyling';
import {Btn} from '../btn-type/Btn';
import {InternalNavLink} from '../btn-type/InternalNavLink';
const toolTipBtnSetup = () => {
    return `
        h3 {
            color: var(--white-00);
            margin-bottom: var(--space-sm);
        }

        ${Btn}, ${InternalNavLink}{
            ${btnColorSetup({
                background: `var(--white-00)`,
                border: `var(--white-00)`,
                txt: `var(--black-01)`,
            })};
            margin-right: 8px;
            &:hover{
                transition: 0.6s;
                ${btnColorSetup({
                    background: `var(--blue-07)`,
                    border: `var(--blue-07)`,
                    txt: `var(--black-01)`,
                })};
            }
        }

        ${Btn}{
            &:first-of-type{
                ${btnColorSetup({
                    background: `none`,
                    border: `none`,
                    txt: `var(--white-00)`,
                })};
                &:hover{
                    transition: 0.6s;
                    ${btnColorSetup({
                        background: `none`,
                        border: `none`,
                        txt: `var(--blue-07)`,
                    })};
                }
            }
        }
    `;
};

export {toolTipBtnSetup};
